import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@app/material.module";
import { TranslateModule } from "@ngx-translate/core";
import { ConfirmDialogComponent } from "./confirm-dialog/confirm-dialog.component";
import { ConfirmSaveDialogComponent } from "./confirm-save-dialog/confirm-save-dialog.component";

@NgModule({
	declarations: [ConfirmDialogComponent, ConfirmSaveDialogComponent],
	imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, TranslateModule],
	exports: [ConfirmDialogComponent, ConfirmSaveDialogComponent],
})
export class GenericDialogsModule {}
